module.exports = __webpack_public_path__ + "static/media/DNA.83d6a664.webp";